export const clinicalChatHistoryCard_style = {
  rootSx: {
    border: '1px solid #E2E2E2',
    borderRadius: '8px',
    cursor: 'pointer',
    p: 1.5,
  },

};
